import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { SessionMainText } from 'domain/assistant/session-elements';
import { AssistantStoreType } from 'models/AssistantStore';
import { ASSISTANTS, getStepInfo } from 'utils/constants/assistant-steps';
import { HistoryProps } from 'utils/history';
import SingleInputScreen from '../SingleInputScreen';

export const PainpointScreen = inject('assistantStore')(
  observer(
    ({
      location,
      assistantStore: { currentAssistantType }
    }: { assistantStore: AssistantStoreType } & HistoryProps) => {
      const stepInfo = getStepInfo('step1_2', currentAssistantType);

      return (
        <SingleInputScreen
          progress={
            stepInfo?.progress || ASSISTANTS.creative_session.step1_2.progress
          }
          barProgress={stepInfo?.percent}
          sidebarHeadline={stepInfo?.header}
          videoId="hCgMr0M9gGY"
          fieldName="painpoint_description"
          dateFieldName="painpoint_description_date"
          largeTextareaFont={true}
          header={<FormattedMessage id="assistant painpoint header" />}
          headerStep={stepInfo?.header}
          placeholderId="assistant painpoint placeholder"
          sidebarScrollTo="painpoint_description"
          showHeader="painpoint_description"
          location={location}
          timerSeconds={120}
        >
          <SessionMainText noMargin={true}>
            <FormattedMessage id="assistant painpoint" />
          </SessionMainText>
        </SingleInputScreen>
      );
    }
  )
);

export default PainpointScreen;
